export default "__VITE_ASSET__Bm4WsrR0__"